import * as React from 'react';
export const rhbSvg = React.forwardRef(function rhbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0067B1',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm28.992 15.803-3.807 3.809-3.808-3.809 3.808-3.807 3.807 3.807Z',
      fill: '#EF3E42',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm2.992 19.975.84-5.896c.188-1.3 1.561-2.435 3.034-2.435 1.494 0 2.203 1.038 2.059 2.034l-.122.859c-.1.72-.631 1.411-1.572 1.923l.963 1.633c.11.18.155.456.11.748-.099.622-.564 1.134-1.073 1.134a.713.713 0 0 1-.63-.387l-1.418-2.45-.244 1.716c-.088.623-.554 1.12-1.052 1.12h-.895Zm3.364-7.113c-.321 0-.62.318-.675.72l-.242 1.776c-.056.402.155.72.476.72.32 0 .62-.318.675-.72l.242-1.777c.056-.4-.155-.72-.476-.72Zm3.507.084c.1-.72.664-1.315 1.24-1.315s.963.595.863 1.315l-.409 2.975h1.14l.421-2.975c.1-.72.665-1.315 1.24-1.315.576 0 .963.595.864 1.315l-.797 5.715c-.1.72-.665 1.315-1.24 1.315-.576 0-.964-.595-.864-1.315l.255-1.854h-1.152l-.254 1.854c-.1.72-.665 1.315-1.24 1.315H8.889l.974-7.03Zm11.201 1.079c-.088.554-.388 1.094-.92 1.592.366.388.521.9.444 1.398l-.078.512c-.199 1.315-1.561 2.45-3.022 2.45h-2.314l.852-5.91c.189-1.3 1.562-2.435 3.034-2.435 1.494 0 2.214 1.037 2.059 2.034l-.055.36Zm-2.845 1.869c-.366 0-.709.373-.776.83l-.166 1.19c-.066.457.178.83.543.83.365 0 .72-.373.786-.83l.166-1.19c.067-.457-.188-.83-.553-.83Zm.443-3.031c-.366 0-.698.374-.776.83l-.132.817c-.078.457.177.83.542.83.366 0 .709-.373.787-.83l.132-.816c.078-.457-.188-.831-.553-.831Z',
      fill: '#fff',
    }),
  );
});
rhbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rhb = {
  category: 'brand',
  colorable: false,
  name: 'rhb',
  svg: rhbSvg,
};
